import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';
const _hoisted_1 = {
  class: "",
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_2 = {
  class: "table_title"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1);

import { nextTick, onMounted, reactive } from 'vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'TableData',
  props: {
    maxHeight: {
      type: Number,
      default: 300
    },
    data: {
      type: Array,
      default: []
    },
    paginationConfig: {
      type: Object,
      default: {
        page: 1,
        limit: 10,
        total: 0
      }
    },
    //时间维度，控制表格行合并， 日，周，月
    timeDimension: {
      type: String,
      default: 'day'
    }
  },
  emits: ['current-change', 'size-change'],

  setup(__props, {
    emit
  }) {
    const props = __props;

    var weekOfYear = require('dayjs/plugin/weekOfYear');

    dayjs.extend(weekOfYear);
    const {
      t
    } = useI18n();
    const tableRef = ref(null);
    const spanArr = ref([]);
    const pos = ref(0); //监听传入的表格数据

    watch(() => props.data, (newVal, oldVal) => {
      tableConfig.config.loading = true;
      tableConfig.data = JSON.parse(JSON.stringify(props.data));

      if (newVal && newVal.length) {
        // 计算table合计数据
        formateData(tableConfig.data);
      }

      tableConfig.config.loading = false;
    });

    const objectSpanMethod = ({
      row,
      column,
      rowIndex,
      columnIndex
    }) => {
      // 合并行---------
      if (columnIndex === 0) {
        //console.log('spanArr',spanArr.value)
        const _row = spanArr.value[rowIndex];
        let _col = 0;

        if (_row > 0) {
          _col = 1;
        } else {
          _col = 0;
        }

        return {
          rowspan: _row,
          colspan: _col
        };
      }
    };

    const getSpanArr = data => {
      //console.log('获取到的数据----', data)
      for (var i = 0; i < data.length; i++) {
        if (i == 0) {
          // 初为1，若下一项和此项相同，就往spanArr数组中追加0
          spanArr.value.push(1);
          pos.value = 0;
        } else {
          // if (data[i].createTime == data[i - 1].createTime) {
          //     // 如果time相等就累加，并且push 0
          //     spanArr.value[pos.value] += 1
          //     spanArr.value.push(0)
          // } else {
          //     // 不相等push 1
          //     spanArr.value.push(1)
          //     pos.value = i
          // }
          const {
            timeDimension
          } = props; //月

          if (timeDimension === 'month') {
            //createTime 创建时间，父组件传过来的
            //判断当前项与上一项的月份是否相同
            if (data[i].createTime.split('-')[1] == data[i - 1].createTime.split('-')[1]) {
              //月份相同
              spanArr.value[pos.value] += 1;
              spanArr.value.push(0);
            } else {
              // 不相等push 1
              spanArr.value.push(1);
              pos.value = i;
            }
          } else if (timeDimension === 'week') {
            //判断当前项与上一项的周数是否相同
            if (data[i].weekCount == data[i - 1].weekCount) {
              //周相同
              spanArr.value[pos.value] += 1;
              spanArr.value.push(0);
            } else {
              // 不相等push 1
              spanArr.value.push(1);
              pos.value = i;
            }
          } else {
            // 判断当前项与上一项的创建时间是否相同
            if (data[i].createTime == data[i - 1].createTime) {
              // 如果time相等就累加，并且push 0
              spanArr.value[pos.value] += 1;
              spanArr.value.push(0);
            } else {
              // 不相等push 1
              spanArr.value.push(1);
              pos.value = i;
            }
          }
        }
      }

      console.log('spanArr', spanArr.value);
    };

    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      // showPageBar: false,
      scrollbarAlwaysOn: true,
      config: {
        loading: false
      },
      maxHeight: props.maxHeight,
      //'row-key': (row) => { return row.id },
      viewLoading: false,
      'span-method': objectSpanMethod
    });
    const columnConfig = reactive({
      columnList: [{
        label: '时间',
        prop: 'time',
        width: 185
      }, {
        label: '上线',
        prop: 'onlineChannel'
      }, {
        label: '新增频道',
        prop: 'addChannel'
      }, {
        label: '下线',
        prop: 'offlineChannel'
      }, {
        label: '删除频道',
        prop: 'delChannel'
      }, {
        label: '更新节目信息',
        prop: 'updateProgram'
      }, {
        label: '更新图片',
        prop: 'updatePicture',
        controller: () => {
          return true;
        }
      }]
    });

    const getData = () => {};

    onMounted(() => {});

    const currentChange = val => {
      tableConfig.paginationConfig.page = val;
      props.paginationConfig.page = val;
      emit('current-change', val);
    };

    const sizeChange = val => {
      tableConfig.paginationConfig.limit = val;
      props.paginationConfig.limit = val;
      emit('size-change', val);
    };

    const formateDataTimeCusArr = ref([]);

    const formateData = data => {
      // console.log('formateDataTimeCusArr', formateDataTimeCusArr.value);
      spanArr.value = [];
      let total = {
        createTime: t('合计'),
        time: t('合计'),
        weekCount: t('合计'),
        onlineChannel: 0,
        addChannel: 0,
        offlineChannel: 0,
        delChannel: 0,
        updateProgram: 0,
        updatePicture: 0,
        subtitle: 0,
        type: 'singleTotal'
      };
      data.forEach(item => {
        // 计算每一项的合计总数
        if (item.type !== 'singleTotal') {
          total.onlineChannel += Number(item.onlineChannel);
          total.addChannel += Number(item.addChannel);
          total.offlineChannel += Number(item.offlineChannel);
          total.delChannel += Number(item.delChannel);
          total.updateProgram += Number(item.updateProgram);
          total.updatePicture += Number(item.updatePicture); //total.subtitle += Number(item.onlineCount);

          item.timeDimension = props.timeDimension;

          if (props.timeDimension === 'month') {
            item.time = item.createTime.split('-')[0] + '-' + item.createTime.split('-')[1];
          } else if (props.timeDimension === 'week') {
            let weekCount = item.createTime.split('\n')[0].split('-')[1];
            let timeArange = item.createTime.split('\n')[1];
            item.time = `${t('第')}${weekCount}${t('周')}<br></br>${timeArange}`;
            item.weekCount = weekCount;
          } else {
            item.time = item.createTime;
          }
        }
      });
      data.push(total);
      console.log('tableConfig.data', tableConfig.data);
      getSpanArr(tableConfig.data);
    };

    watch(() => props.maxHeight, val => {
      // console.log('props.maxHeight', val);
      if (val) {
        nextTick(() => {
          tableConfig['maxHeight'] = val;
          tableRef.value.commonTableRef.doLayout();
        });
      }
    }, {
      deep: true
    }); // 判断是否显示提示

    const showToolTip = label => {
      if (label === '上线' || label === '下线') {
        return true;
      } else {
        return false;
      }
    }; // toolTips要提示的文字


    const toolTipContent = label => {
      return label === '上线' ? t('为节目被操作的次数，例如节目被操作2次上线，数据即为2。') : t('为节目被操作的次数，例如节目被操作2次下线，数据即为2。');
    };

    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_common_table, {
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        onSizeChange: sizeChange,
        "pagination-config": __props.paginationConfig,
        render: getData,
        "column-list": columnConfig.columnList,
        onCurrentChange: currentChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          title: _withCtx(scope => [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(_ctx.$t(scope.label)) + " ", 1), showToolTip(scope.label) ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            effect: "light",
            "popper-class": "tps",
            content: toolTipContent(scope.label),
            placement: "top"
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 2
          }, 1032, ["content"])) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "column-list"])])), [[_directive_loading, tableConfig.config.loading]]);
    };
  }

});